import { render, staticRenderFns } from "./vehiclecheckview.html?vue&type=template&id=6149bf38&external"
import script from "./vehiclecheckview.vue?vue&type=script&lang=js"
export * from "./vehiclecheckview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports